import axios from 'axios';
import * as db from '../db/db';
import { AppContext } from "../context/applicationContext";
import moment from "moment";
const env = process.env.NODE_ENV;
export const context = AppContext;
const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';

export const axiosMethods = {
    getNewToken(expireIn) {
        var isMobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        var now = moment.utc();
        var new_dateNow = null;
        var getNewToken = false;
        if (expireIn !== null) {
            var inValidToken = moment(now).isAfter(expireIn);

            if (inValidToken) {//Ако токъна е изтекъл и не можем да вземем нов
                db.idbMethods.clear(db.userInfo);
            } else {
                if (isMobile) {
                    var isAfter = moment(now).add(2, 'days').isAfter(expireIn);
                    if (isAfter === true) {
                        getNewToken = true;
                    }
                } else {
                    new_dateNow = moment(now).add(5, 'minutes');
                    var isAfter = new_dateNow.isAfter(expireIn);
                    if (isAfter === true) {
                        getNewToken = true;
                    }
                }
            }
        }
        return getNewToken;
    },
    refreshToken(expireIn, token) {
        const link = baseUrl + '/api/RefreshToken';
        var isMobileDevice = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        if (token !== undefined && token !== null) {
            return axios.post(link,
                {
                    "IsPWAMobile": isMobileDevice
                }, { headers: { 'Authorization': 'Bearer ' + token } })
                .then(res => {
                    if (res.status === 200) {
                        db.idbMethods.getAll(db.userInfo).then((userInfo) => {
                            if (userInfo !== undefined || userInfo !== null || userInfo.length !== 0) {
                                var user = userInfo[0];
                                user.Expires = res.data.Expires;
                                user.Token = res.data.Token;
                                db.idbMethods.set(user, db.userInfo);
                            }
                        }).catch(err => {
                            console.error(err)
                        });
                        return res;
                    } else {
                        throw new Error('Refresh token error');
                    }
                }).catch(error => {
                    console.log('error', error);
                    this.logOut();
                    return error;
                });
        }
    },
    logOut(){
    this.context.setStateCustom('userId', null);
    db.idbMethods.clear(db.userInfo);
    db.idbMethods.clear(db.holidaysForApprove);
    db.idbMethods.clear(db.holidaysForApproveList);
    db.idbMethods.clear(db.myHolidays);
    }
}

axios.interceptors.request.use((config) => {
    var isLogin = config.url;
    var token = null;
    var expireIn = null;

  return db.idbMethods.getAll(db.userInfo).then((userInfo) => {
        if (userInfo !== undefined && userInfo !== null && userInfo.length !== 0) {
            expireIn = userInfo[0].Expires;
            token = userInfo[0].Token;

            if (token !== undefined && token !== null) {
                if (isLogin.indexOf("loginForm") < 0) {
                    if (axiosMethods.getNewToken(expireIn)) {
                        axiosMethods.refreshToken(expireIn, token).then((res) => {
                            config.headers = { 'Authorization': 'Bearer ' + token,'Cache-Control':'no-cache'}
                            return config
                        }).catch(err => {
                            console.error(err);
                            return err;
                        });
                    };
                    config.headers = { 'Authorization': 'Bearer ' + token,'Cache-Control':'no-cache'}
                }
            }
            return config;
        }
        return config;
        
    }).catch(err => {
        console.error(err);
        this.logOut();
        return err;
    });
}, error => {
    this.logOut();
    return Promise.reject(error)
});

